<template>
  <div class="action">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 20px">
      <el-breadcrumb-item :to="{ path: '/members/actions' }">Actions</el-breadcrumb-item>
      <el-breadcrumb-item>{{ actionName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <h1>{{ actionName }}</h1>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form ref="form" :model="form" label-width="140px" style="max-width: 600px">
          <div v-if="action === 'user_info'">
            <el-form-item label="User Name">
              <el-col :span="12">
                <el-input v-model="form.first_name" placeholder="John" clearable></el-input>
              </el-col>
              <el-col :span="12">
                <el-input v-model="form.last_name" placeholder="Kamvari" clearable></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="Email/User id">
              <el-col :span="12">
                <el-input v-model="form.email" placeholder="Email" clearable></el-input>
              </el-col>
              <el-col :span="12">
                <el-input v-model="form.user_id" placeholder="User id" clearable></el-input>
              </el-col>
            </el-form-item>

            <!-- <el-form-item label="Parent id">
          <el-input v-model="form.parent_id" placeholder="parent_id"></el-input>
        </el-form-item> -->
            <el-form-item label="Student">
              <el-col :span="8">
                <el-input type="text" v-model="form.student_first_name" placeholder="First Name" :minlength="4"
                  clearable></el-input>
              </el-col>
              <el-col :span="8">
                <el-input v-model="form.student_last_name" placeholder="Last Name" clearable></el-input>
              </el-col>
              <el-col :span="8">
                <el-input v-model="form.student_id" placeholder="Student id" clearable></el-input>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="searchUser">Search</el-button>
            </el-form-item>
          </div>
          <div v-if="action === 'send_notifications'">
            <el-form-item label="Notice id">
              <el-input v-model="form.notice_id" placeholder="notice_id"></el-input>
            </el-form-item>
          </div>
          <div v-if="action === 'send_service_emails'">
            <el-form-item label="School">
              <OrgSelectionAdmin @return-selection="updateSchoolId" :multiple="true" />
            </el-form-item>
          </div>
          <div v-if="action === 'new_term'">
            <el-form-item label="School">
              <OrgSelectionAdmin @return-selection="updateSchoolId" />
            </el-form-item>
          </div>
          <div v-if="action === 'send_login_emails'">
            <el-form-item label="School">
              <OrgSelectionAdmin @return-selection="updateSchoolId" :multiple="true" />
            </el-form-item>
          </div>
          <div v-if="action === 'move_children_up_a_year'">
            <el-form-item label="School">
              <OrgSelectionAdmin @return-selection="updateSchoolId" />
            </el-form-item>
            <el-form-item label="Remove Simulation">
              <el-switch v-model="form.removeSimulation" active-color="#13ce66" inactive-color="#ccc"></el-switch>
            </el-form-item>
          </div>
          <div v-if="action === 'change_school_and_year'">
            <el-form-item label="From School">
              <OrgSelectionAdmin @return-selection="updateSchoolId" :showOnlySchoolSelector="true" />
            </el-form-item>
            <el-form-item label="From Year">
              <el-select v-model="form.current_year" placeholder="Select Current Year" style="width: 100%">
                <el-option v-for="year in currentSchoolYears" :label="year.name + '  ( ' + year.value + ' )'"
                  :value="year.value" :key="year.value"></el-option>
              </el-select> </el-form-item><br />
            <el-form-item label="To School">
              <OrgSelectionAdmin @return-selection="updateNewSchoolId" :showOnlySchoolSelector="true" />
            </el-form-item>
            <el-form-item label="To Year">
              <el-select v-model="form.new_year" placeholder="Select New Year" style="width: 100%">
                <el-option v-for="year in newSchoolYears" :label="year.name + '  ( ' + year.value + ' )'"
                  :value="year.value" :key="year.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Ignore students updated in last 30d">
              <el-switch v-model="form.ignoreRecent" active-color="#13ce66" inactive-color="#ccc"></el-switch>
            </el-form-item>
            <el-form-item label="Remove Simulation">
              <el-switch v-model="form.removeSimulation" active-color="#13ce66" inactive-color="#ccc"></el-switch>
            </el-form-item>
          </div>
          <div v-if="action === 'remove_user_schools'">
            <el-form-item label="School">
              <OrgSelectionAdmin @return-selection="updateSchoolId" :multiple="true" />
            </el-form-item>
          </div>
          <div v-if="action === 'remove_non_user_data'">
            <el-form-item label="All Schools"> </el-form-item>
          </div>
          <div v-if="action === 'send_admin_messages'">
            <el-form-item label="School/Council">
              <OrgSelectionAdmin :multiple="true" @return-selection="updateSchoolId" />
            </el-form-item>
            <el-form-item label="Subject">
              <el-input type="text" autosize placeholder="Subject" v-model="form.subject">
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="Content:"> </el-form-item> -->
            <mc-wysiwyg v-model="form.content" placeholder="Enter text here" :height="200" :hide="hide"
              style="background: white; margin-left: 0px; text-align: left"></mc-wysiwyg>
            <br />
            <br />
          </div>
          <div v-if="action === 'change_travel_mode'">
            <el-form-item label="Journey Profile id">
              <el-input v-model="form.journey_id" placeholder="journey_id"></el-input>
            </el-form-item>
            <el-form-item label="Activity zone">
              <el-select v-model="form.region" placeholder="please select your zone">
                <el-option label="CAR" value="CAR"></el-option>
                <el-option label="TAXI" value="TAXI"></el-option>
                <el-option label="WALKING" value="WALKING"></el-option>
                <el-option label="BICYCLING" value="BICYCLING"></el-option>
                <el-option label="TRAIN" value="TRAIN"></el-option>
                <el-option label="BUS" value="BUS"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="action === 'csv_snapshot'">
            <div>
              <h4>Generate Csv</h4>
              <span>Generate Csv table</span>
              <el-input v-model="csv_table_name" placeholder="table" style="width: 200px"></el-input>
              <el-button @click="generateCsvSnapshot" type="primary">Generate CSV</el-button>
            </div>
            <hr>
            <h4>Download Csv</h4>
            <el-form-item label="CSV Name">
              <el-select v-model="form.csv_path" placeholder="Select Csv" style="width: 300px">
                <el-option v-for="item in csv_snapshot_list" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <div v-if="csv_link">
              <a :href="csv_link" target="_blank">Download Csv file</a>
              <br>
              <br>
            </div>
          </div>
          <div v-if="action === 'stap_journey_count'">
            <el-form-item label="Stap Data Upload id">
              <el-input v-model="form.step_journeys_upload_id" placeholder="step_journeys_upload_id"></el-input>
            </el-form-item>
          </div>
          <div v-if="action === 'integration_add_school_token'">
            <el-form-item label="Provider school id">
              <el-input v-model="form.provider_school_id" placeholder="provider_school_id"></el-input>
            </el-form-item>
            <el-form-item label="school_id">
              <el-input v-model="form.school_id" placeholder="school_id"></el-input>
            </el-form-item>
            <el-form-item label="token">
              <el-input v-model="form.token" placeholder="token"></el-input>
            </el-form-item>
            <el-form-item label="notes">
              <el-input v-model="form.notes" placeholder="notes"></el-input>
            </el-form-item>
          </div>
          <div v-if="action === 'remove_school'">
            <el-form-item label="school_id">
              <OrgSelectionAdmin @return-selection="updateSchoolId" :multiple="false" />
            </el-form-item>
          </div>
          <div v-if="action === 'disable_school'">
            <el-form-item label="school_id">
              <OrgSelectionAdmin @return-selection="updateSchoolId" :multiple="false" />
            </el-form-item>
          </div>
          <div v-if="action === 'change_travel_mode'">
            <el-form-item label="Journey Profile id">
              <el-input v-model="form.journey_id" placeholder="journey_id"></el-input>
            </el-form-item>
            <el-form-item label="Activity zone">
              <el-select v-model="form.region" placeholder="please select your zone">
                <el-option label="CAR" value="CAR"></el-option>
                <el-option label="TAXI" value="TAXI"></el-option>
                <el-option label="WALKING" value="WALKING"></el-option>
                <el-option label="BICYCLING" value="BICYCLING"></el-option>
                <el-option label="TRAIN" value="TRAIN"></el-option>
                <el-option label="BUS" value="BUS"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="action === 'all'">
            <el-form-item label="Activity name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="Activity zone">
              <el-select v-model="form.region" placeholder="please select your zone">
                <el-option label="Zone one" value="shanghai"></el-option>
                <el-option label="Zone two" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Activity time">
              <el-col :span="11">
                <el-date-picker type="date" placeholder="Pick a date" v-model="form.date1" style="width: 100%">
                </el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-time-picker placeholder="Pick a time" v-model="form.date2" style="width: 100%"></el-time-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="Instant delivery">
              <el-switch v-model="form.delivery"></el-switch>
            </el-form-item>
            <el-form-item label="Activity type">
              <el-checkbox-group v-model="form.type">
                <el-checkbox label="Online activities" name="type"></el-checkbox>
                <el-checkbox label="Promotion activities" name="type"></el-checkbox>
                <el-checkbox label="Offline activities" name="type"></el-checkbox>
                <el-checkbox label="Simple brand exposure" name="type"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="Resources">
              <el-radio-group v-model="form.resource">
                <el-radio label="Sponsor"></el-radio>
                <el-radio label="Venue"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Activity form">
              <el-input type="textarea" v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">Create</el-button>
              <el-button>Cancel</el-button>
            </el-form-item>
          </div>
          <el-form-item v-if="action !== 'user_info' && action !== 'verify_notices'">
            <el-popconfirm title="Are you sure you want to proceed ?" confirmButtonText="Yes" cancelButtonText="No"
              @confirm="onSubmit">
              <el-button type="primary" slot="reference">Submit</el-button>
            </el-popconfirm>
            <!-- <el-popconfirm
              title="Are you sure you want to proceed ?"
              confirmButtonText="Yes"
              cancelButtonText="No"
              @confirm="onSubmit"
              v-if="action == 'new_term' || action == 'move_children_up_a_year'"
              >{school_id}
              <el-dropdown
                split-button
                type="primary"
                :disabled="school_id.length == 0 ? true : false"
                slot="reference"
                @click="addAutomationJob(action, 'now')"
              >
                Submit Now
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    ><el-button
                      type="text"
                      @click="addAutomationJob(action, 'tomorrow')"
                      >Process it tomorrow morning</el-button
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-popconfirm> -->
            <el-button @click="goBack">Cancel</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <ActionsHistory v-if="
          action !== 'user_info' &&
          action !== 'send_admin_messages' &&
          action !== 'verify_notices'
        " :path="action" :school_id="this.school_id[0]" />
      </el-col>
    </el-row>
    <el-row v-if="action == 'user_info'">
      <el-col :span="24">
        <el-table :data="items" style="width: 100%">
          <el-table-column fixed prop="id" label="Id" sortable>
            <template slot-scope="scope">
              <el-button v-if="scope.row.email" @click="openParent(scope.row.id)" type="primary"
                :class="{ staff: scope.row.is_staff }" size="mini"><i class="fas fa-user"></i> {{ scope.row.id }}
              </el-button>
              <el-button v-if="!scope.row.email" @click="openStudent(scope.row.id)" type="primary" size="mini"><i
                  class="fas fa-child"></i> {{ scope.row.id }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="first_name" label="First name" sortable></el-table-column>
          <el-table-column prop="last_name" label="Last name" sortable></el-table-column>
          <el-table-column prop="email" label="Email" sortable></el-table-column>
          <el-table-column prop="verified" label="Verified" sortable></el-table-column>
          <el-table-column prop="created_at" label="Created at" sortable></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row v-if="action === 'send_admin_messages'">
      <el-col :span="24">
        <el-table :data="items" style="width: 100%">
          <el-table-column prop="id" label="Id" sortable width="100"></el-table-column>
          <el-table-column prop="school_id" label="School id" sortable width="100"></el-table-column>
          <el-table-column prop="council_id" label="Council id" sortable width="100"></el-table-column>
          <el-table-column prop="created_at" label="Created at" sortable width="100"></el-table-column>
          <el-table-column prop="is_read" label="Is Read" sortable width="70"></el-table-column>
          <el-table-column prop="subject" label="Subject" sortable width="150"></el-table-column>
          <el-table-column prop="content" label="Content" sortable></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row v-if="action === 'verify_notices'">
      <el-col :span="24">
        <el-table :data="items" style="width: 100%" v-loading="tableLoading">
          <el-table-column prop="id" label="Id" sortable width="100"></el-table-column>
          <el-table-column prop="school" label="School" sortable></el-table-column>
          <el-table-column prop="message" label="Message" sortable></el-table-column>
          <el-table-column label="Actions">
            <template slot-scope="scope">
              <el-button type="primary" @click="verifyNotice(scope.row.id, 1)" size="small">Verify</el-button>
              <el-button type="warning" @click="verifyNotice(scope.row.id, 5)" size="small">No notif</el-button>
              <el-button type="danger" @click="verifyNotice(scope.row.id, 0)" size="small">Remove</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
import SingleParent from "@/modals/SingleParent.vue";
import SingleStudent from "@/modals/SingleStudent.vue";
import ApiService from "@/services/ApiService";
import ActionsHistory from "@/components/admin/ActionsHistory.vue";
import { McWysiwyg } from "@mycure/vue-wysiwyg";
export default {
  data() {
    return {
      action: "",
      actionName: "",
      form: {
        removeSimulation: false,
        email: null,
        first_name: null,
        last_name: null,
        user_id: null,
      },
      csv_table_name: "",
      currentSchoolYears: [],
      newSchoolYears: [],
      school_id: 99999999,
      paramToTitle: {
        user_info: "User Info",
        reset_password: "Reset Password",
        verify_notices: "Verify Notices",
        new_term: "New Term",
        send_notifications: "Send Mobile Notifications",
        send_service_emails: "Send Service Emails",
        move_children_up_a_year: "Move Children up a year",
        send_login_emails: "Send Login Emails",
        remove_user_schools: "Remove User Schools",
        remove_non_user_data: "Remove Non User Data",
        send_admin_messages: "Send Admin Messages",
        change_school_and_year: "Change School and Year",
        remove_school: "Remove School",
        disable_school: "Disable School",
        csv_snapshot: "CSV Snapshot",
      },
      items: [],
      messages: [],
      tableLoading: false,
      removeSimulation: false,
      csv_snapshot_list: [],
      csv_link: "",
    };
  },
  components: {
    OrgSelectionAdmin,
    ActionsHistory,
    McWysiwyg,
  },
  methods: {
    generateCsvSnapshot() {
      ApiService.sadminApi.generateCsvSnapshot(this.csv_table_name).then((response) => {
        this.$notify.success({
          title: "Success",
          message: "CSV Snapshot generated",
        });
        this.getCsvSnapshotList();
      }).catch((error) => {
        let message = "CSV Snapshot generation failed";

        if (error.response.status == 403) {
          message = "You are not authorized to generate this CSV Snapshot";
        }

        this.$notify.error({
          title: "Error",
          message: message,
        });
      });
    },
    getCsvSnapshotList() {
      ApiService.sadminApi.getCsvSnapshots().then((response) => {
        this.csv_snapshot_list = response.data.reverse();
      });
    },
    searchUser() {
      const payload = JSON.parse(JSON.stringify(this.form));
      if (payload.removeSimulation == false) {
        delete payload.removeSimulation;
      }
      ApiService.sadminApi.searchParentsChildren(payload).then((response) => {
        this.items = response.data;
      });
      // searchUser
    },
    addAutomationJob(scriptName, whenToLaunch) {
      const payload = {
        script_name: scriptName,
        whenToLaunch: whenToLaunch,
        school_ids: this.form.school_id,
      };
      // console.log("Payload", payload);
      return;
      // ApiService.sadminApi.postAutomationJob();
      // alert(name);
    },
    onSubmit() {
      // console.log("schools", this.school_id);
      this.submitAction();
    },
    submitAction() {
      switch (this.action) {
        case "send_admin_messages":
          if (!this.form.content || this.form.content == "") {
            this.$notify.error({
              title: "Error",
              message: "Content is missing",
            });
            return;
          }
          if (!this.form.school_id) {
            this.$notify.error({
              title: "Error",
              message: "Please select at least one school",
            });
            return;
          }
          ApiService.sadminApi.saveAdminMessage(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Message sent",
            });
            this.form = {};
            this.action = "";
            this.$nextTick(() => {
              this.action = "send_admin_messages";
              this.loadData();
            });
            // this.$router.go();
          });

          break;
        case "send_notifications":
          ApiService.sadminApi.sendNotifications(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Sent",
            });
            this.form = {};
            this.action = "";
            this.$nextTick(() => {
              this.action = "send_notifications";
            });
          });
          break;
        case "send_service_emails":
          ApiService.sadminApi.sendServiceEmails(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Service emails sent",
            });
            this.form = {};
            this.action = "";
            this.$nextTick(() => {
              this.action = "send_service_emails";
              this.loadData();
            });
          });
          break;
        case "send_login_emails":
          ApiService.sadminApi.sendLoginEmails(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Login emails sent",
            });
            this.form = {};
            this.action = "";
            this.$nextTick(() => {
              this.action = "send_login_emails";
              this.loadData();
            });
          });
          break;
        case "new_term":
          this.$store.dispatch("loading", true);
          ApiService.sadminApi.newTerm(this.form).then((resp) => {
            this.$store.dispatch("loading", false);
            this.$notify.success({
              title: "Success",
              message: "New term finished",
            });
            this.form = {};
            this.action = "";
            this.$nextTick(() => {
              this.action = "new_term";
              this.loadData();
            });
          });
          break;
        case "move_children_up_a_year":
          this.$store.dispatch("loading", true);
          ApiService.sadminApi.moveChildrenUpAYear(this.form).then((resp) => {
            this.$store.dispatch("loading", false);
            this.$notify.success({
              title: "Success",
              message: "Moved children up a year",
            });
            this.form = {};
            this.action = "";
            this.$nextTick(() => {
              this.action = "move_children_up_a_year";
              this.loadData();
            });
          });
          break;
        case "remove_user_schools":
          ApiService.sadminApi.removeUsersSchools(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Removed user schools",
            });
            this.form = {};
            this.action = "";
            this.$nextTick(() => {
              this.action = "remove_user_schools";
              this.loadData();
            });
          });
          break;
        case "remove_non_user_data":
          ApiService.sadminApi.removeParentsWithoutSchool().then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Removed parents without schools",
            });
            this.form = { removeSimulation: false };
            this.$nextTick(() => {
              this.action = "remove_non_user_data";
              this.loadData();
            });
          });
          break;
        case "change_school_and_year":
          ApiService.sadminApi
            .changeStudentsSchoolAndYear(this.form)
            .then((resp) => {
              this.$notify.success({
                title: "Success",
                message:
                  "Change School and year finished. " +
                  resp.data.students +
                  " students",
              });
              this.form = { removeSimulation: false };
              this.action = "";
              this.$nextTick(() => {
                this.action = "change_school_and_year";
                this.loadData();
              });
            });
          break;
        case "change_travel_mode":
          ApiService.sadminApi.changeTravelMode(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Change travel mode finished. ",
            });
            this.form = { removeSimulation: false };
            this.action = "";
            this.$nextTick(() => {
              this.action = "change_travel_mode";
              this.loadData();
            });
          });
          break;
        case "integration_add_school_token":
          ApiService.sadminApi
            .integrationAddSchoolToken(this.form)
            .then((resp) => {
              this.$notify.success({
                title: "Success",
                message: "School token has been added.",
              });
              this.form = { removeSimulation: false };
              this.action = "";
              this.$nextTick(() => {
                this.action = "integration_add_school_token";
                // this.loadData();
              });
            });
          break;
        case "integration_pending_schools":
          ApiService.sadminApi
            .integrationPendingSchools(this.form)
            .then((resp) => {
              // this.$notify.success({
              //   title: "Success",
              //   message: "Change travel mode finished. ",
              // });
              this.form = { removeSimulation: false };
              this.action = "";
              this.$nextTick(() => {
                this.action = "integration_pending_schools";
                // this.loadData();
              });
            });
          break;
        case "remove_school":
          ApiService.sadminApi.removeSchool(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "School has been removed.",
            });
          });
          break;
        case "disable_school":
          ApiService.sadminApi.disableSchool(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "School has been disabled.",
            });
          });
          break;
        case "stap_journey_count":
          ApiService.sadminApi.stapDataJourneyCount(this.form).then((resp) => {
            this.$notify.success({
              title: "Success",
              message: "Finished.",
            });
          });
          break;
        case "csv_snapshot":
          ApiService.sadminApi.getSignedCsvFile(this.form.csv_path).then((resp) => {
            this.csv_link = resp.data;
            this.$notify.success({
              title: "Success",
              message: "Csv file downloaded",
            });
            this.form = { csv_path: "" };
          });
          break;
        default:
          break;
      }
    },
    updateSchoolId(selection) {
      // alert(selection);
      // console.log("Selection", selection);
      this.form.school_id = selection.organization_id;
      this.school_id = selection.organization_id;
      ApiService.generalApi
        .getOrgGroups(selection.organization_id, "STUDENT_YEAR")
        .then((response) => (this.currentSchoolYears = response.data));
    },
    updateNewSchoolId(selection) {
      this.form.new_school_id = selection.organization_id;
      ApiService.generalApi
        .getOrgGroups(selection.organization_id, "STUDENT_YEAR")
        .then((response) => (this.newSchoolYears = response.data));
    },
    openParent(userId) {
      this.$modal.show(
        SingleParent,
        {
          options: {
            profilePicture: true,
          },
          userId,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: 700,
          adaptive: true,
          width: 900,
          // pivotY: 0
        }
      );
    },
    openStudent(studentId) {
      this.$modal.show(
        SingleStudent,
        {
          options: {
            profilePicture: true,
          },
          studentId,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: 500,
          adaptive: true,
          width: 700,
          // pivotY: 0
        }
      );
    },
    goBack() {
      this.$router.go(-1);
    },
    loadData() {
      if (this.action === "send_admin_messages") {
        this.tableLoading = true;
        ApiService.sadminApi.getAllAdminMessages().then((resp) => {
          this.items = resp.data;
          this.tableLoading = false;
        });
      } else if (this.action === "verify_notices") {
        this.tableLoading = true;
        ApiService.sadminApi.getPendingNotices().then((resp) => {
          this.items = resp.data;
          this.tableLoading = false;
        });
      } else if (this.action === "csv_snapshot") {
        this.tableLoading = true;
        this.getCsvSnapshotList();
      }
      this.$forceUpdate();
    },
    verifyNotice(noticeId, status) {
      this.tableLoading = true;
      ApiService.sadminApi.verifyNotice(noticeId, status).then((resp) => {
        this.tableLoading = false;
        if (status === 0) {
          this.$notify.success({
            title: "Success",
            message: "Notice has been removed",
          });
        } else if (status === 1) {
          this.$notify.success({
            title: "Success",
            message: "Notice has been verified",
          });
        }
        this.loadData();
      });
    },
  },
  mounted() {
    this.actionName = this.paramToTitle[this.$route.params.action];
    this.action = this.$route.params.action;
    this.loadData(this.action);
    // ApiService.generalApi.getYears("ADMIN").then((resp) => {
    //   this.years = resp;
    // });
  },
};
</script>
<style>
button.staff {
  background-color: green !important;
}
</style>
